export const documentStorage = {
  title: 'Dokumentumtár',
  subtitle: 'Dokumentumok és mappák kezelése',
  
  // Actions
  actions: {
    upload: 'Feltöltés',
    newFolder: 'Új mappa',
    download: 'Letöltés',
    delete: 'Törlés',
    rename: 'Átnevezés',
    move: 'Áthelyezés',
    search: 'Keresés...',
    back: 'Vissza',
    close: 'Bezárás',
    save: 'Mentés',
    cancel: 'Mégse',
    confirm: 'Megerősítés',
    preview: 'Előnézet',
    filter: 'Szűrés',
    allCategories: 'Minden kategória',
    allTags: 'Minden címke',
    addTag: 'Címke hozzáadása...',
    newCategory: 'Új kategória',
    edit: 'Szerkesztés',
    sortBy: 'Rendezés',
    sortName: 'Név szerint',
    sortDate: 'Dátum szerint',
    sortSize: 'Méret szerint',
    allTypes: 'Minden típus',
    typePdf: 'PDF',
    typeImage: 'Kép',
    typeDoc: 'Dokumentum',
    selectAll: 'Összes kijelölése',
    deselectAll: 'Kijelölés megszüntetése',
    bulkDelete: 'Kijelöltek törlése',
    bulkDeleteConfirm: 'Biztosan törli a kijelölt {{count}} dokumentumot?',
    storageUsage: 'Tárhely használat',
  },
  
  // Folders
  folders: {
    root: 'Gyökér',
    allDocuments: 'Minden dokumentum',
    empty: 'Nincsenek mappák',
    name: 'Mappa neve',
    namePlaceholder: 'Új mappa neve...',
    parent: 'Szülő mappa',
    create: 'Mappa létrehozása',
    deleteConfirm: 'Biztosan törli ezt a mappát?',
    deleteWarning: 'A mappában lévő dokumentumok nem törlődnek, csak gyökérbe kerülnek.',
    documentCount: '{{count}} dokumentum',
  },
  
  // Documents
  documents: {
    empty: 'Nincsenek dokumentumok',
    emptyHint: 'Töltsön fel vagy hozzon létre új dokumentumot',
    title: 'Cím',
    category: 'Kategória',
    customer: 'Ügyfél',
    size: 'Méret',
    created: 'Létrehozva',
    noFile: 'Nincs csatolt fájl',
    tags: 'Címkék',
    deleteConfirm: 'Biztosan törli ezt a dokumentumot?',
    deleteWarning: 'Ez a művelet nem visszavonható.',
    editTitle: 'Dokumentum szerkesztése',
    moveTitle: 'Dokumentum áthelyezése',
    moveFolder: 'Célmappa',
    moveFolderHint: 'Válassza ki az új mappát',
    uploadSuccess: 'Dokumentum sikeresen feltöltve',
    uploadError: 'Hiba a feltöltés során',
    deleteSuccess: 'Dokumentum törölve',
    deleteError: 'Hiba a törlés során',
  },
  
  // Upload
  upload: {
    title: 'Dokumentum feltöltése',
    dragHere: 'Húzza ide a fájlt vagy kattintson a kiválasztáshoz',
    dropHere: 'Ejtse ide a fájlt a feltöltéshez',
    orClick: 'vagy kattintson a böngészéshez',
    selectFile: 'Fájl kiválasztása',
    titleField: 'Dokumentum címe',
    titlePlaceholder: 'Adjon meg címet...',
    categoryField: 'Kategória',
    customerField: 'Ügyfél',
    selectCustomer: 'Válasszon ügyfelet...',
    general: 'Általános',
    noCategory: 'Nincs kategória',
    tags: 'Címkék',
    tagsHint: 'Enterrel adhat hozzá új címkét',
  },
  
  // Messages
  messages: {
    folderCreated: 'Mappa létrehozva',
    folderDeleted: 'Mappa törölve',
    folderError: 'Hiba a mappa művelet során',
    loading: 'Betöltés...',
    categoryCreated: 'Kategória létrehozva',
    categoryError: 'Hiba a kategória létrehozásakor',
  },
  
  // Categories
  categories: {
    title: 'Kategóriák',
    create: 'Új kategória',
    name: 'Kategória neve',
    namePlaceholder: 'Kategória neve...',
    color: 'Szín',
    icon: 'Ikon',
  },
  
  // Preview
  preview: {
    title: 'Dokumentum előnézet',
    noPreview: 'Nem jeleníthető meg előnézet',
    noPreviewHint: 'Töltse le a fájlt a megtekintéshez',
    openInNewTab: 'Megnyitás új lapon',
  },
  
  move: {
    title: 'Áthelyezés',
    targetFolder: 'Célmappa',
    root: 'Gyökér (nincs mappa)',
  },
  
  edit: {
    title: 'Dokumentum szerkesztése',
    titleField: 'Dokumentum címe',
    categoryField: 'Kategória',
    tags: 'Címkék',
    tagsHint: 'Enterrel adhat hozzá új címkét',
  },
};
